
import { computed, defineComponent, PropType, ref } from 'vue'
import { HierarchyAssignment } from '@/modules/members'
import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import MembersFormFieldIsAccountManager from '@/components/members/form-fields/is-account-manager.vue'
import MembersFormFieldCluster from '@/components/members/form-fields/cluster.vue'
import MembersFormFieldArea from '@/components/members/form-fields/area.vue'
import MembersFormFieldDepartment from '@/components/members/form-fields/department.vue'
import MembersFormFieldUnit from '@/components/members/form-fields/unit.vue'
import MembersFormFieldTeam from '@/components/members/form-fields/team.vue'
import MembersFormFieldPersonnelId from '@/components/members/form-fields/personnel-id.vue'
import MembersFormFieldCompanyName from '@/components/members/form-fields/company-name.vue'
import { useOrganizationModule } from '@/modules/organizations'

export default defineComponent({
    name: 'members-edit-member-hierarchy-assignment-form',
    components: {
        MembersFormFieldIsAccountManager,
        MembersFormFieldCompanyName,
        MembersFormFieldCluster,
        MembersFormFieldArea,
        MembersFormFieldDepartment,
        MembersFormFieldUnit,
        MembersFormFieldTeam,
        MembersFormFieldPersonnelId
    },
    props: {
        organizationId: {
            type: String,
            required: true
        },
        memberId: {
            type: String,
            required: true
        },
        hierarchyAssignment: {
            type: Object as PropType<HierarchyAssignment>,
            required: true
        },
        updateCallback: {
            type: Function as PropType<(t: HierarchyAssignment) => void>,
            required: true
        }
    },
    setup (props, { emit }) {
        const { updateOrganizationMemberHierarchyAssignment, getOrganization } = useOrganizationModule()
        const { submitForm, createOnSuccess } = useFormModule()
        const form = ref<QForm>()

        const hierarchyAssignmentModel = ref(props.hierarchyAssignment)
        const companyNameAndDepartmentHint = ref('')

        async function getCompanyNameAndDepartmentHint () {
            const org = await getOrganization(props.organizationId)
            if (org.ssoReportingDimensions) {
                companyNameAndDepartmentHint.value = 'Please note that this field is populated from SSO'
            } else {
                companyNameAndDepartmentHint.value = ''
            }
        }
        getCompanyNameAndDepartmentHint()
        const sendRequest = async () => updateOrganizationMemberHierarchyAssignment(
            props.organizationId,
            props.memberId,
            {
                organizationId: props.organizationId,
                memberId: props.memberId,
                ...hierarchyAssignmentModel.value,
                personnelId: hierarchyAssignmentModel.value.personnelId === '' ? null : hierarchyAssignmentModel.value.personnelId
            })
        const onCloseDialog = () => emit('closeDialog')

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Member hierarchy assignment has been updated')
        ).then(() => {
            onCloseDialog()
            props.updateCallback(hierarchyAssignmentModel.value)
        })

        return {
            hierarchyAssignmentModel,
            onSubmit,
            form,
            onCloseDialog,
            companyNameAndDepartmentHint
        }
    }
})
